export default __webpack_public_path__ + "static/media/Gitau.97fcb777.png";